import React from 'react'

export type ArrowDirection = 'left' | 'right' | 'up' | 'down'

interface ArrowNextProps {
	width?: number | string
	height?: number | string
	color?: string
	onClick?: () => void
	style?: React.CSSProperties
	/** Направление стрелки */
	direction?: ArrowDirection
}

// Маппинг направлений на углы поворота
const DIRECTION_ROTATION: Record<ArrowDirection, number> = {
	down: 0,
	up: 180,
	left: 90,
	right: -90,
}

const ArrowNext: React.FC<ArrowNextProps> = ({
	width = 24,
	height = 24,
	color = '#7F7F84',
	onClick,
	style,
	direction = 'down',
}) => {
	const rotation = DIRECTION_ROTATION[direction]

	return (
		<svg
			width={width}
			height={height}
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			onClick={onClick}
			style={{
				cursor: 'pointer',
				transform: `rotate(${rotation}deg)`,
				transition: 'transform 0.2s ease',
				...style,
			}}
		>
			<path
				d='M20 8L12 16L4 8'
				stroke={color}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	)
}

export default ArrowNext
